Mosaic.setPlugins([require('./../../@scandipwa/webpack-i18n-runtime/src/plugin/App.plugin.js'),
require('./../../@scandiweb/amasty-gdpr/src/plugin/AppContext.plugin.js'),
require('./../../@scandiweb/amasty-gdpr/src/plugin/Checkboxes.plugin.js'),
require('./../../@scandiweb/amasty-gdpr/src/plugin/ConfigQuery.plugin.js'),
require('./../../@scandiweb/amasty-gdpr/src/plugin/Footer.plugin.js'),
require('./../../@scandiweb/amasty-gdpr/src/plugin/MyAccount.plugin.js'),
require('./../../@scandiweb/amasty-gdpr/src/plugin/OrderAndReturn.plugin.js'),
require('./../../@scandiweb/amasty-gdpr/src/plugin/Popup.plugin.js'),
require('./../../@scandiweb/amasty-gdpr/src/plugin/Router.plugin.js'),
require('./../../@scandiweb/amasty-gdpr/src/plugin/SignIn.plugin.js'),
require('./../../@satisfly/product-labels/src/plugin/ProductCard.plugin.js'),
require('./../../@satisfly/product-labels/src/plugin/ProductGallery.plugin.js'),
require('./../../@satisfly/product-labels/src/plugin/ProductList.plugin.js'),
require('./../../@satisfly/product-labels/src/plugin/Router.plugin.js'),
require('./../../@satisfly/product-labels/src/plugin/StoreReducer.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/config/ConfigDispatcher.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/config/ConfigQuery.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/config/ConfigReducer.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/config/MyAccountQuery.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/config/ProductListQuery.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/cart.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/checkout.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/errorMessage.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/filter.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/general.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/list.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/notFound.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/pageReload.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/product.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/search.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/sort.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/user.plugin.js'),
require('./../../@scandiweb/gtm/src/plugin/events/wishlist.plugin.js'),
require('./../../@scandiweb/magefan-blog/src/plugin/ConfigQuery.plugin.js'),
require('./../../@scandiweb/magefan-blog/src/plugin/Menu.plugin.js'),
require('./../../@scandiweb/magefan-blog/src/plugin/Router.plugin.js'),
require('./../../@scandiweb/magefan-blog/src/plugin/SideBarContext.plugin.js'),
require('./../../@satisfly/checkout-saved-form-fields/src/plugin/CartQuery.plugin.js'),
require('./../../@satisfly/checkout-saved-form-fields/src/plugin/Checkout.plugin.js'),
require('./../../@satisfly/checkout-saved-form-fields/src/plugin/CheckoutAddressBook.plugin.js'),
require('./../../@satisfly/checkout-saved-form-fields/src/plugin/CheckoutBilling.plugin.js'),
require('./../../@satisfly/checkout-saved-form-fields/src/plugin/CheckoutPayments.plugin.js'),
require('./../../@satisfly/checkout-saved-form-fields/src/plugin/CheckoutShipping.plugin.js'),
require('./../../@satisfly/checkout-saved-form-fields/src/plugin/CheckoutSuccess.plugin.js'),
require('./../../@satisfly/checkout-saved-form-fields/src/plugin/MyAccount.plugin.js'),
require('./../../@satisfly/checkout-saved-form-fields/src/plugin/MyAccountAddressForm.plugin.js'),
require('./../../@satisfly/checkout-saved-form-fields/src/plugin/StoreReducer.plugin.js')]);
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import 'Util/Polyfill';
import 'Style/main';

import { render } from 'react-dom';

import App from 'Component/App';

import 'src/lbx/AddToCart';
import 'src/lbx/AddToWishList';
import 'src/lbx/AddToProductAvailabilityList';

// let's register service-worker
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        const swUrl = '/service-worker.js';

        navigator.serviceWorker.register(swUrl, { scope: '/' });
    });
}

render(<App />, document.getElementById('root'));
